import { ExpectedProps } from '@lib/factory/serverprops';
import { NextPage } from 'next';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { PageLayout } from '@components/PageLayout/PageLayout';
import s from '../paymentPage.module.scss';
import cn from 'classnames';
import { useTranslation } from '@hooks/useTranslation';
import { TabItems } from '@components/Pages/PaymentsPages/TabItems';
import { Breadcrumb } from '@components/UIKit/Breadcrumb/Breadcrumb';
import { List } from '@components/Pages/PaymentsPages/HistoryPage/List/List';
import { LinksEnum } from '@specs/navigation';
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = ({}) => {
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  useEffect(() => {
    router.replace(LinksEnum.FEED_POSTS);
  }, []);
  return <PageLayout showBackIconOnMobile data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
            <div className={s.paymentPage}>
                <div className={cn(s.paymentPage__container, '_container')}>
                    <Breadcrumb data-sentry-element="Breadcrumb" data-sentry-source-file="index.tsx" />
                    <div className={s.paymentPage__top}>
                        <h1 className={cn(s.paymentPage__title, '_title')}>
                            {tr({
              id: 'payments.pages.currency.title'
            })}
                        </h1>
                        <div className={s.paymentPage__tabs}>
                            <TabItems data-sentry-element="TabItems" data-sentry-source-file="index.tsx" />
                        </div>
                    </div>
                    <List data-sentry-element="List" data-sentry-source-file="index.tsx" />
                </div>
            </div>
        </PageLayout>;
};
export default Page;